// dependencies
import React from "react";

import { faGripLines } from "@fortawesome/pro-regular-svg-icons";
import { faCircleX } from "@fortawesome/pro-solid-svg-icons";

// components
import { Avatar } from "@performyard/py-components";

import Icon from "../../Icon";
// styles
import css from "./DraggableEmployee.module.scss";

export type DraggableEmployeeProps = {
	employeeId: string;
	employeeName: string;
	onRemove: () => void;
	version: "old" | "new";
};

const DraggableEmployee = (props: DraggableEmployeeProps) => {
	const { employeeId, employeeName, onRemove, version = "new", ...rest } = props;
	return (
		<>
			{/* temporary old version to handle the author/signer select.
			once Monty has the updated design, we can remove the old version. */}
			{version === "old" ? (
				<div className={css.oldDraggableWrapper} {...rest}>
					<Icon size="sm" className={css.dragHandle} icon={faGripLines} />
					<Avatar dangerouslySetClassName={css.avatar} id={employeeId} size={20} name={employeeName} />
					<div className={css.employeeName}>{employeeName}</div>
					<div
						data-testid={`checklistItemRemove-${employeeId}`}
						className={css.removeEmployee}
						onClick={() => onRemove()}
					>
						<Icon icon={faCircleX} size="small" />
					</div>
				</div>
			) : (
				<div className={css.draggableWrapper} {...rest}>
					<Icon className={css.dragHandle} icon={faGripLines} />
					<div className={css.employeeContainer}>
						<Avatar dangerouslySetClassName={css.avatar} id={employeeId} size={20} name={employeeName} />
						<div className={css.employeeName}>{employeeName}</div>
						<div
							data-testid={`checklistItemRemove-${employeeId}`}
							className={css.removeEmployee}
							onClick={() => onRemove()}
						>
							<Icon icon={faCircleX} size="small" />
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default DraggableEmployee;
